export const calculateInps = (ral, data, params = {}) => {
  const aliquoteInps = data.aliquote_inps;
  const selectedYear = params.year || '2026';
  const massimale = aliquoteInps[`massimale${selectedYear}`] || aliquoteInps.massimale2026;
  const imponibile = Math.min(ral, massimale);
  const esoneroContributivo = params.esoneroContributivo ?? false;
  const madreLavoratrice = params.madreLavoratrice ?? false;
  const mensilita = params.mensilita || 14;
  const lordoMensile = imponibile / mensilita;
  const apprendistato = params.apprendistato ?? false;
  let inpsDipendente = 0;
  let inpsAzienda = 0;

  const aliquotaLavoratore = (params.alinpsDip ?? 0) / 100;
  const aliquotaAzienda = (params.alinpsDat ?? 0) / 100;

  if (esoneroContributivo && lordoMensile <= aliquoteInps.esonero2024.secondoScaglione.soglia) {
    if(apprendistato){
      inpsDipendente = 0;
    } else if (lordoMensile <= aliquoteInps.esonero2024.primoScaglione.soglia) {
      inpsDipendente = Math.round(lordoMensile * 12 * (Math.max(aliquotaLavoratore - aliquoteInps.esonero2024.primoScaglione.sconto, 0)) + lordoMensile * (mensilita - 12) * aliquotaLavoratore);
    } else {
      inpsDipendente = Math.round(lordoMensile * 12 * (Math.max(aliquotaLavoratore - aliquoteInps.esonero2024.secondoScaglione.sconto, 0)) + lordoMensile * (mensilita - 12) * aliquotaLavoratore);
    }
  } else if (madreLavoratrice) {
    inpsDipendente = Math.round(Math.max(imponibile * aliquotaLavoratore - aliquoteInps.esonero_madre_lavoratrice.soglia, 0));
  } else {
    inpsDipendente = Math.round(imponibile * aliquotaLavoratore);
  }

  // Contributo aggiuntivo 1% a carico del lavoratore (art. 3-ter L. 438/1992) sulla quota
  // di imponibile che eccede la prima fascia di retribuzione pensionabile, entro il massimale.
  // Per redditi sotto la soglia l'eccedenza è 0 e non incide.
  const primaFascia = aliquoteInps[`primaFascia${selectedYear}`];
  if (primaFascia) {
    const aliquotaAggiuntiva = aliquoteInps.aliquotaAggiuntiva ?? 0.01;
    inpsDipendente += Math.round(Math.max(0, imponibile - primaFascia) * aliquotaAggiuntiva);
  }

  inpsAzienda = Math.round(imponibile * aliquotaAzienda);

  return { inpsDipendente, inpsAzienda };
}

export const calculateImponibileIrpef = (ral, inpsDipendente, params = {}) => {
  const rientroCervelli = params.rientroCervelli ?? false;
  const percentualeImponibile = parseFloat(params.imponibileCervelli ?? 1);
  let imponibileIrpef = rientroCervelli && ral <= 600000 ? (ral - inpsDipendente) * percentualeImponibile : ral - inpsDipendente;
  return imponibileIrpef;
}

export const calculateIrpef = (imponibileIrpef, data, params = {}) => {
const selectedYear = params.year || '2026';

  // Get year-specific rates or fall back to default
  const aliquoteIrpef = data.aliquote_irpef[selectedYear] || data.aliquote_irpef.default;
  let irpefLorda = 0;

  if (imponibileIrpef >= 0 && imponibileIrpef <= 28000) {
    irpefLorda = Math.round(imponibileIrpef * aliquoteIrpef.primoScaglione.aliquota);
  } else if (imponibileIrpef > 28000 && imponibileIrpef <= 50000) {
    irpefLorda = Math.round((imponibileIrpef - 28000) * aliquoteIrpef.secondoScaglione.aliquota + aliquoteIrpef.secondoScaglione.scaglioniPrecedenti);
  } else if (imponibileIrpef > 50000) {
    irpefLorda = Math.round((imponibileIrpef - 50000) * aliquoteIrpef.else.aliquota + aliquoteIrpef.else.scaglioniPrecedenti);
  }

  return irpefLorda;
}

export const calculateAddizionaleRegionale = (imponibileIrpef, data, irpefNetta, params = {}) => {
  const selectedYear = params.year || '2026';
  const aliquoteRegionali = data.aliquote_regionali?.[selectedYear];
  const regione = params.regione || '';
  let addizionaleRegionale = 0;
  if (irpefNetta > 0 && regione && aliquoteRegionali?.[regione]) {
    if (imponibileIrpef >= 0 && imponibileIrpef <= 15000) {
      addizionaleRegionale = Math.round(imponibileIrpef * aliquoteRegionali[regione].primoScaglione);
    } else if (imponibileIrpef > 15000 && imponibileIrpef <= 28000) {
      addizionaleRegionale = Math.round(15000 * aliquoteRegionali[regione].primoScaglione + (imponibileIrpef - 15000) * aliquoteRegionali[regione].secondoScaglione);
    } else if (imponibileIrpef > 28000 && imponibileIrpef <= 50000) {
      addizionaleRegionale = Math.round(15000 * aliquoteRegionali[regione].primoScaglione + 13000 * aliquoteRegionali[regione].secondoScaglione + (imponibileIrpef - 28000) * aliquoteRegionali[regione].terzoScaglione);
    } else if (imponibileIrpef > 50000) {
      addizionaleRegionale = Math.round(15000 * aliquoteRegionali[regione].primoScaglione + 13000 * aliquoteRegionali[regione].secondoScaglione + 22000 * aliquoteRegionali[regione].terzoScaglione + (imponibileIrpef - 50000) * aliquoteRegionali[regione].else);
    }
  } else if (irpefNetta > 0 && regione && !aliquoteRegionali?.[regione]) {
    console.warn(`Aliquote regionali mancanti per ${regione} nell'anno ${selectedYear}`);
  }

  return addizionaleRegionale;
}

export const calculateAddizionaleComunale = (imponibileIrpef, irpefNetta, params = {}) => {
  if (irpefNetta <= 0) return 0;

  // Sotto la soglia di esenzione deliberata dal comune l'addizionale non e' dovuta.
  const esenzione = parseFloat(params.esenzione ?? 0);
  if (esenzione > 0 && imponibileIrpef <= esenzione) return 0;

  // Comuni multialiquota: aliquote progressive per scaglioni di reddito
  // (art. 1 c. 11 DL 138/2011). scaglioni = [[limiteSuperiore|null, aliquota%], ...]
  const scaglioni = params.scaglioni;
  if (Array.isArray(scaglioni) && scaglioni.length > 0) {
    let totale = 0;
    let precedente = 0;
    for (const [fino, aliquota] of scaglioni) {
      const limite = fino ?? Infinity;
      const quota = Math.min(imponibileIrpef, limite) - precedente;
      if (quota > 0) totale += quota * (aliquota / 100);
      if (imponibileIrpef <= limite) break;
      precedente = limite;
    }
    return Math.round(totale);
  }

  const aliquotaComunale = parseFloat(params.addizionaleComunale ?? 0);
  return Math.round(imponibileIrpef * (aliquotaComunale / 100));
}

export const calculateDetrazioniIrpef = (imponibileIrpef, params = {}) => {
  let detrazioneLavoroDipendente = 0;

  if (imponibileIrpef >= 0 && imponibileIrpef <= 15000) {
    detrazioneLavoroDipendente = 1955;
  } else if (imponibileIrpef > 15000 && imponibileIrpef <= 28000) {
    detrazioneLavoroDipendente = Math.round(1910 + 1190 * ((28000 - imponibileIrpef) / 13000));
  } else if (imponibileIrpef > 28000 && imponibileIrpef <= 50000) {
    detrazioneLavoroDipendente = Math.round(1910 * ((50000 - imponibileIrpef) / 22000));
  }

  // art. 13 c. 1.1 TUIR: la maggiorazione spetta per reddito complessivo
  // (non RAL) tra 25.001 e 35.000 euro
  if (imponibileIrpef > 25000 && imponibileIrpef <= 35000) {
    detrazioneLavoroDipendente += 65;
  }

  return detrazioneLavoroDipendente;
}

export const calculateDetrazioneConiuge = (imponibileIrpef, params = {}) => {
  let detrazioneConiuge = 0;
  const coniugeCarico = params.coniugeCarico ?? false;

  if (coniugeCarico) {
    if (imponibileIrpef <= 15000) {
      detrazioneConiuge = 800 - 110 * (imponibileIrpef / 15000);
    } else if (imponibileIrpef <= 40000) {
      detrazioneConiuge = 690;

      // maggiorazioni fisse art. 12 c. 1 lett. b TUIR
      if (imponibileIrpef > 29000 && imponibileIrpef <= 29200) {
        detrazioneConiuge += 10;
      } else if (imponibileIrpef > 29200 && imponibileIrpef <= 34700) {
        detrazioneConiuge += 20;
      } else if (imponibileIrpef > 34700 && imponibileIrpef <= 35000) {
        detrazioneConiuge += 30;
      } else if (imponibileIrpef > 35000 && imponibileIrpef <= 35100) {
        detrazioneConiuge += 20;
      } else if (imponibileIrpef > 35100 && imponibileIrpef <= 35200) {
        detrazioneConiuge += 10;
      }
    } else if (imponibileIrpef <= 80000) {
      detrazioneConiuge = 690 * ((80000-imponibileIrpef)/40000);
    }
  }

  return Math.round(detrazioneConiuge);
}

// art. 12 c. 1 lett. c TUIR: detrazione per figli a carico dai 21 ai 29 anni
// (dal 2025, L. 207/2024, si perde al compimento dei 30) o con disabilita'
// accertata (L. 104/92) senza limiti di eta', per i quali spettano 400 euro
// in piu'. Sotto i 21 anni il sostegno e' l'Assegno Unico INPS, fuori busta paga.
// La soglia di azzeramento (95.000) cresce di 15.000 per ogni figlio oltre il primo.
// percentualeFigli: 100 se la detrazione e' intera, 50 se ripartita tra i genitori.
export const calculateDetrazioneFigli = (imponibileIrpef, params = {}) => {
  const numeroFigli = Math.max(parseInt(params.numeroFigli) || 0, 0);
  if (numeroFigli === 0) return 0;
  const numeroFigliDisabili = Math.min(Math.max(parseInt(params.numeroFigliDisabili) || 0, 0), numeroFigli);
  const percentuale = (parseFloat(params.percentualeFigli) || 100) / 100;

  const soglia = 95000 + 15000 * (numeroFigli - 1);
  const quoziente = (soglia - imponibileIrpef) / soglia;
  if (quoziente <= 0) return 0;

  const detrazioneTeorica = 950 * numeroFigli + 400 * numeroFigliDisabili;
  return Math.round(detrazioneTeorica * Math.min(quoziente, 1) * percentuale);
}

// art. 12 c. 1 lett. d TUIR: dal 2025 la detrazione per altri familiari a carico
// spetta solo per gli ascendenti conviventi (genitori, nonni): 750 euro teorici
// ciascuno, da ripartire pro quota tra chi ne ha diritto.
export const calculateDetrazioneAscendenti = (imponibileIrpef, params = {}) => {
  const numeroAscendenti = Math.max(parseInt(params.numeroAscendenti) || 0, 0);
  if (numeroAscendenti === 0) return 0;
  const quoziente = (80000 - imponibileIrpef) / 80000;
  if (quoziente <= 0) return 0;
  return Math.round(750 * numeroAscendenti * Math.min(quoziente, 1));
}

export const calculateUlterioreDetrazione = (ral, inpsDipendente, params = {}) => {
  let ulterioreDetrazione = 0;
  let redditoComplessivo = ral - inpsDipendente;
  const cuneoFiscale = params.cuneoFiscale ?? false;
  if(cuneoFiscale){
    switch (true) {
      case redditoComplessivo > 20000 && redditoComplessivo <= 32000:
        ulterioreDetrazione = 1000;
        break;
      case redditoComplessivo > 32000 && redditoComplessivo <= 40000:
        ulterioreDetrazione = 1000 * ((40000 - redditoComplessivo) / 8000);
        break;
      default:
        ulterioreDetrazione = 0;
    }
  }

  return Math.round(ulterioreDetrazione);

}

// Trattamento integrativo (art. 1 DL 3/2020). Le soglie di 15.000 e 28.000
// euro guardano al reddito complessivo, che per legge (art. 1 c. 3 DL 3/2020,
// istruzioni AdE quadro C sez. V) include per intero la quota esente dei
// regimi impatriati e docenti/ricercatori: `redditoComplessivo` va quindi
// passato al lordo dello sconto (RAL - INPS), mentre imposta lorda e
// detrazioni restano quelle calcolate sulla sola quota imponibile. Se il
// parametro manca si usa l'imponibile, che coincide fuori dai regimi agevolati.
export const calculateBonus100 = (imponibileIrpef,detrazioneLavoroDipendente,irpefLorda, detrazioneConiuge, ulterioreDetrazione, params = {}) => {
  let bonus100 = 0;
  const redditoComplessivo = Number.isFinite(parseFloat(params.redditoComplessivo))
    ? parseFloat(params.redditoComplessivo)
    : imponibileIrpef;
  let altreDetrazioni = 0;
  if (params.altreDetrazioni !== undefined) {
    altreDetrazioni = parseFloat(params.altreDetrazioni) || 0;
  }
  const detrazioneFigli = params.detrazioneFigli ?? 0;
  const detrazioneAscendenti = params.detrazioneAscendenti ?? 0;
  let sommaDetrazioni = detrazioneLavoroDipendente + detrazioneConiuge + detrazioneFigli + detrazioneAscendenti + ulterioreDetrazione + altreDetrazioni;

  const bonus100Flag = params.bonus100Flag ?? false;
  if (bonus100Flag) {
    // fino a 15.000: spetta se l'imposta lorda supera la detrazione lavoro
    // ridotta di 75 euro (L. 207/2024, circolare AdE 4/E 2025); la via
    // dell'incapienza (comma 1-bis) non si applica a questa fascia
    if (redditoComplessivo <= 15000) {
      bonus100 = irpefLorda > detrazioneLavoroDipendente - 75 ? 1200 : 0;
    } else if (redditoComplessivo <= 28000) {
      bonus100 = sommaDetrazioni > irpefLorda ? Math.min(1200, sommaDetrazioni - irpefLorda) : 0;
    }
  }
  return bonus100;
}

// Bonus cuneo fiscale (art. 1 c. 4 L. 207/2024). Per il comma 9 la quota
// esente dei regimi impatriati e docenti/ricercatori conta per intero nel
// reddito che decide fascia e percentuale (`redditoComplessivo`, RAL - INPS),
// ma la percentuale si applica alla sola quota imponibile (circolare AdE
// 4/E/2025, par. 1.2, esempio 3). Senza il parametro si usa l'imponibile.
export const calculateSommaIntegrativa = (imponibileIrpef, params = {}) =>{
  let sommaIntegrativa = 0;
  const cuneoFiscaleCheckbox = params.cuneoFiscale ?? false;
  const redditoComplessivo = Number.isFinite(parseFloat(params.redditoComplessivo))
    ? parseFloat(params.redditoComplessivo)
    : imponibileIrpef;
  if(cuneoFiscaleCheckbox){
    switch (true) {
      case redditoComplessivo <= 8500:
        sommaIntegrativa = imponibileIrpef * 0.071;
        break;
      case redditoComplessivo > 8500 && redditoComplessivo <= 15000:
        sommaIntegrativa = imponibileIrpef * 0.053;
        break;
      case redditoComplessivo > 15000 && redditoComplessivo <= 20000:
        sommaIntegrativa = imponibileIrpef * 0.048;
        break;
      default:
        sommaIntegrativa = 0;
    }
  }
  return Math.round(sommaIntegrativa);
}

export const calculateIrpefNetta = (irpefLorda, detrazioneLavoroDipendente, detrazioneConiuge, ulterioreDetrazione, detrazioneFigli = 0, detrazioneAscendenti = 0) => {
  return Math.max(irpefLorda - detrazioneLavoroDipendente - detrazioneConiuge - detrazioneFigli - detrazioneAscendenti - ulterioreDetrazione, 0);
}

export const calculateTotaleIrpef = (irpefNetta, addizionaleComunale, addizionaleRegionale) => {
  return Math.round(irpefNetta + addizionaleComunale + addizionaleRegionale)
}

export const calculateRetribuzioneAnnuaNetta = (ral, inpsDipendente, totaleIrpef, sommaIntegrativa, bonus100) => {
  let ran = Math.round(ral - inpsDipendente - totaleIrpef + sommaIntegrativa + bonus100);
  const total = totaleIrpef + inpsDipendente + ran;
  if (total !== ral + sommaIntegrativa + bonus100) {
    const difference = total - (ral + sommaIntegrativa + bonus100);
    ran -= difference;
  }
  return ran;
}

export const calculateRetribuzioneMensileNetta = (retribuzioneAnnuaNetta, params = {}) => {
  const mensilita = params.mensilita || document.querySelector('input[name="mensilita"]:checked')?.value || 14;
  return Math.round(retribuzioneAnnuaNetta / mensilita);
}

// Calcola netto mensilità ordinaria e aggiuntive (13ª/14ª) ripartendo i valori annui già calcolati.
// Quote uniformi su tutte le mensilità: RAL, INPS, IRPEF lorda e addizionali.
// Solo sulle 12 mensilità ordinarie ricadono i benefici da lavoro dipendente:
// detrazioni (quelle effettivamente applicate, = irpefLorda - irpefNetta), cuneo fiscale e bonus 100.
// La ripartizione torna sempre col netto annuo (vedi calculateRetribuzioneAnnuaNetta).
export const calculateNettoMensilita = (retribuzioneAnnuaNetta, breakdown = {}, params = {}) => {
  const mensilita = Number(params.mensilita) || 12;
  if (mensilita <= 12) return null;

  const ral = breakdown.ral ?? 0;
  const inpsDipendente = breakdown.inpsDipendente ?? 0;
  const irpefLorda = breakdown.irpefLorda ?? 0;
  const irpefNetta = breakdown.irpefNetta ?? 0;
  const sommaIntegrativa = breakdown.sommaIntegrativa ?? 0;
  const bonus100 = breakdown.bonus100 ?? 0;
  const nAggiuntive = mensilita - 12;

  // Benefici che spettano alle sole 12 mensilità ordinarie: detrazioni effettivamente
  // applicate (irpefLorda - irpefNetta), riduzione del cuneo e Trattamento Integrativo.
  const beneficiOrdinari = (irpefLorda - irpefNetta) + sommaIntegrativa + bonus100;

  // La mensilità aggiuntiva (13ª/14ª) segue il cedolino reale: ogni mensilità sconta la
  // STESSA aliquota IRPEF media (quota uniforme irpefLorda/mensilità), non un'aliquota
  // marginale. Verificato su busta paga Zucchetti: ordinaria e 14ª hanno la stessa aliquota
  // effettiva (~33% a parità di scaglione), perché il sostituto annualizza ogni mensilità.
  // Sulla aggiuntiva NON ricadono le addizionali (rateizzate sulle sole ordinarie) né i
  // benefici (detrazioni/cuneo/bonus, che spettano alle sole 12 ordinarie).
  const nettoMensilitaAggiuntiva = Math.round((ral - inpsDipendente - irpefLorda) / mensilita);

  // L'ordinaria assorbe per differenza benefici e addizionali (già nel netto annuo):
  // a redditi bassi/medi vince il beneficio (13ª più bassa), a redditi alti vincono le
  // addizionali (13ª leggermente più alta). La ripartizione torna sempre col netto annuo.
  const nettoMensilitaOrdinaria = Math.round((retribuzioneAnnuaNetta - nettoMensilitaAggiuntiva * nAggiuntive) / 12);

  return { nettoMensilitaOrdinaria, nettoMensilitaAggiuntiva, beneficiOrdinari };
};

export const calculateInail = (ral, data) =>{
  let imponibile = Math.max(data.inail.minimale, Math.min(ral, data.inail.massimale));
  let inail = Math.round(imponibile / 1000 * 30);
  return inail;
}
